<template>
  <el-dialog title="审批流程" :visible.sync="formVisible" :close-on-click-modal="false" width="600px">
    <el-steps direction="vertical" :active="0">
      <el-step title="审批人" status="process" v-if="firstInfo.length">
        <img src="@/assets/icon1.png" alt="" slot="icon" style="width: 24px;height: 24px;" />
        <div slot="description" v-for="item in firstInfo" :key="item.id">
          <div class="flexs boxs">
            <div class="flexs boxs-left">
              <el-image style="width: 50px; height: 50px;margin-right: 5px;" :src="item.auditHeadImg" fit="cover" v-if="item.auditHeadImg"></el-image>
              <img style="width: 50px; height: 50px;margin-right: 5px;" src="@/assets/du_logo.png" v-else />
              <div>
                <div class="flexs">
                  <div>{{item.auditName}}</div>
                  <div class="label-box">{{item.auditLevelName}}</div>
                </div>
                <div>{{item.auditPho}}</div>
              </div>
            </div>
            <div :style="{'color':item.processingStatus==3?'#E73F3F':''}">{{item.processingStatus |setType}}<span v-if="![1,5].includes(item.processingStatus)">·{{item.auditTime}}</span></div>
          </div>
          <div v-if="item.rejectCause"  style="margin-bottom: 5px;">{{item.rejectCause}}</div>
          <div v-if="item.auditImgUrls"><el-image style="width: 50px; height: 50px;margin-right: 5px;" :preview-src-list="[itt]" v-for="(itt,idx) in item.auditImgUrls.split(',')" :key="idx" :src="itt" fit="cover"></el-image></div>
        </div>
      </el-step>
      <el-step title="审批人" status="process">
        <img src="@/assets/icon2.png" alt="" slot="icon" style="width: 24px;height: 24px;" />
        <div slot="description" v-for="item in list" :key="item.id">
          <div class="flexs boxs">
            <div class="flexs boxs-left">
              <el-image style="width: 50px; height: 50px;margin-right: 5px;" :src="item.auditHeadImg" fit="cover" v-if="item.auditHeadImg"></el-image>
              <img style="width: 50px; height: 50px;margin-right: 5px;" src="@/assets/du_logo.png" v-else />
              <div>
                <div class="flexs">
                  <div>{{item.auditName}}</div>
                  <div class="label-box">{{item.auditLevelName}}</div>
                </div>
                <div>{{item.auditPho}}</div>
              </div>
            </div>
            <div :style="{'color':item.processingStatus==3?'#E73F3F':''}">{{item.processingStatus |setType}}<span v-if="![1,5].includes(item.processingStatus)">·{{item.auditTime}}</span></div>
          </div>
          <div v-if="item.rejectCause" style="margin-bottom: 5px;">{{item.rejectCause}}</div>
          <div v-if="item.auditImgUrls"><el-image style="width: 50px; height: 50px;margin-right: 5px;" :preview-src-list="[itt]" v-for="(itt,idx) in item.auditImgUrls.split(',')" :key="idx" :src="itt" fit="cover"></el-image></div>
        </div>
      </el-step>
    </el-steps>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="formVisible = false">
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import userApi from '@/api/user/index'
export default {
  data() {
    return {
      // form: initFormBean(),
      formVisible: false,
      list: [],
      firstInfo: [],
      info: {}
    }
  },
  created() {

  },
  filters: {
    setType(val) {
      console.log('val', val)
      const Maps = new Map([
        [1, '未审批'],
        [2, '已同意'],
        [3, '已驳回'],
        [4, '已撤销'],
        [5, '审批中'],
      ])
      return Maps.get(val)
    }
  },
  methods: {
    resetForm() {
      // this.form = initFormBean()
    },
    handleUpdate(row) {
      this.resetForm()
      this.formVisible = true
      userApi.findAuditListByProcessingId({ processingId: row.id }).then(({
        data
      }) => {
        /* this.companyOption = data.list[0].content.split(',') */
        // this.configList=data.list
        // console.log("配置: ", data);
        this.list = data.filter(i => i.levelId == 1)
        this.firstInfo = data.filter(i => i.levelId > 1)
      })
      // this.$nextTick(() => {
      //   this.$refs['dataForm'].clearValidate()
      // })
    },
  }
}
</script>
<style lang="scss" scoped>
.label-box {
  background: linear-gradient(180deg, #d4ab42 0%, #f2d58c 100%);
  border-radius: 8px 11px 11px 0;
  color: #fff;
  padding: 0 4px;
  margin-left: 5px;
}
.boxs {
  width: 100%;
  justify-content: space-between;
  margin-bottom: 10px;
}
::v-deep .el-step__description {
  padding-right: 10% !important;
}
::v-deep .el-step__icon.is-text {
  border: none !important;
}
::v-deep .el-select {
  width: 100%;
}
::v-deep .el-cascader {
  width: 100%;
}
.el-form-item--small.el-form-item {
  width: 48%;
  display: inline-block;
  vertical-align: top;
}
.el-date-editor--datetimerange.el-input,
.el-date-editor--datetimerange.el-input__inner {
  width: 100%;
}
.el-form-item--small.el-form-item.width100 {
  width: 97%;
}
</style>
